import { render, staticRenderFns } from "./editHousekeepingFeeConfig.vue?vue&type=template&id=6312a245"
import script from "./editHousekeepingFeeConfig.vue?vue&type=script&lang=js"
export * from "./editHousekeepingFeeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports